import type { RouteContrat } from './route.js';
import { ROUTES_PAR_TAG } from './routes.js';

export * from './route.js';

export const PREFIXE_API = '/api/v1';

/** Groupes de routes (tags OpenAPI), dans l'ordre de l'architecture §3.3. */
export const TAGS = [
  { nom: 'auth', description: 'Connexion de l’équipe, lien magique, OTP, sessions.' },
  { nom: 'impersonation', description: '« Voir en tant que » : démarrer, confirmer une action, terminer, historique.' },
  { nom: 'dossiers', description: 'Dossiers, tableau de bord, journal horodaté.' },
  { nom: 'procedure', description: 'Étapes P0 à P9 : ajouter, sauter, réordonner.' },
  { nom: 'tasks', description: 'File du jour.' },
  { nom: 'decisions', description: 'Décisions réservées à Isabelle.' },
  { nom: 'genealogy', description: 'Personnes, liens, successions, options, dévolution, exports PDF et GEDCOM.' },
  { nom: 'assets', description: 'Biens et titres.' },
  { nom: 'estimates', description: 'Estimation des parts (équipe seulement).' },
  { nom: 'notary', description: 'Interrogations notariales et renonciations.' },
  { nom: 'deadlines', description: 'Échéances légales.' },
  { nom: 'documents', description: 'Téléversement reprenable, versions, aperçus, validation, checklist.' },
  { nom: 'mandates', description: 'Mandats, devis et procurations à signer (DocuSeal).' },
  { nom: 'messaging', description: 'Fils, messages, rattachement, envoi, programmation, aperçu de lien.' },
  { nom: 'followups', description: 'Plans de relance, pause, reprise, simulation de cadence.' },
  { nom: 'templates', description: 'Modèles de messages versionnés.' },
  { nom: 'billing', description: 'Règles, versions, factures, calendrier de collecte, échéances.' },
  { nom: 'payments', description: 'Liens de paiement.' },
  { nom: 'privacy', description: 'Consentements, sensibles, partage, notes internes, demandes RGPD.' },
  { nom: 'admin', description: 'Utilisateurs, rôles, études, clercs, paramètres légaux.' },
  { nom: 'beta', description: 'Questions BETA dues, réponses, réglages appris.' },
  { nom: 'portal', description: 'Portail du mandant et des héritiers : action unique, branche, reste dû.' },
  { nom: 'clerc', description: 'Espace de la clerc de notaire.' },
  { nom: 'notaire', description: 'Espace du notaire.' },
  { nom: 'sync', description: 'Synchronisation hors ligne (push, pull).' },
  { nom: 'webhooks', description: 'Webhooks entrants signés : Jockalia, e-mail, Stripe, GoCardless, DocuSeal.' },
  { nom: 'system', description: 'Santé et version du service.' },
] as const;

export const ROUTES: readonly RouteContrat[] = TAGS.flatMap((t) => ROUTES_PAR_TAG[t.nom]);

const PAR_ID = new Map(ROUTES.map((r) => [r.id, r]));

export function routeParId(id: string): RouteContrat {
  const r = PAR_ID.get(id);
  if (!r) throw new Error(`Route inconnue du contrat : ${id}`);
  return r;
}
